import { render, staticRenderFns } from "./SessionExpiredModal.vue?vue&type=template&id=73e7481a&lang=pug"
import script from "./SessionExpiredModal.vue?vue&type=script&lang=js"
export * from "./SessionExpiredModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports